import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3c0c235f&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=3c0c235f&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0c235f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c0c235f')) {
      api.createRecord('3c0c235f', component.options)
    } else {
      api.reload('3c0c235f', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=3c0c235f&scoped=true", function () {
      api.rerender('3c0c235f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/QuotationCustomer/details/index.vue"
export default component.exports